import React from "react";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

const StyledCard = styled(Card)(({ theme }) => ({
	borderRadius: "1rem",
	boxShadow: "none",
	position: "relative",
	minWidth: 200,
	minHeight: 200,
	[theme.breakpoints.up("sm")]: {
		minHeight: 400,
	},
	[theme.breakpoints.up("md")]: {
		minHeight: 600,
	},
	"&:after": {
		content: '""',
		display: "block",
		position: "absolute",
		width: "100%",
		height: "64%",
		bottom: 0,
		zIndex: 1,
		background: "linear-gradient(to top, #000, rgba(0,0,0,0))",
	},
}));

const StyledCardMedia = styled(CardMedia)({
	position: "absolute",
	width: "100%",
	height: "100%",
	top: 0,
	left: 0,
	zIndex: 0,
	backgroundPosition: "top",
});

const Content = styled("div")(({ theme }) => ({
	padding: theme.spacing(1, 1),
	position: "absolute",
	zIndex: 2,
	bottom: 0,
	width: "100%",
}));

export default function CardVente({ cover, children }) {
	return (
		<StyledCard>
			<StyledCardMedia image={cover} />
			<Content>
				<Typography
					variant="body1"
					color={"rgba(255, 255, 255, 0.82)"}
				>
					{children}
				</Typography>
			</Content>
		</StyledCard>
	);
}
